<div [class]="classPrefix('MainPod')">
  <section [class]="classPrefix('Pod0')">
    <wml-form-zero [class]="classPrefix('Pod0Item0')" [props]="mainForm"></wml-form-zero>

  </section>

</div>
